import { create } from 'zustand';
import { AuthState, createAuthSlice } from './authStore';
import { ProjectsState } from 'Zustand/types/projectsTypes';
import { createProjectsSlice } from './projectsStore';


type BoundStore = AuthState & ProjectsState;

export const useBoundStore = create<BoundStore>()((...a) => ({
  ...createAuthSlice(...a),
  ...createProjectsSlice(...a),
}));
